import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '../../config';

export default {
    NEWS_LIST: [
        {
            timestamp: '2020-05-28',
            message: <Fragment>WikINM Facelift (v4)</Fragment>
        },       
		{
            timestamp: '2017-04-04',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Jinxed'}>Jinxed</Link> was released</Fragment>
        },
        {
            timestamp: '2016-06-18',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#100.000 To Live Longer'}>100.000 To Live Longer</Link> was released</Fragment>
        },
        {
            timestamp: '2015-12-25',
            message: <Fragment>The christmas video for the year 2015 - <Link to={CONFIG.ROUTES.PROJECTS + '#Eine INM Weihnachtsgeschichte'}>Eine INM Weihnachtsgeschichte</Link> - was released</Fragment>
        },
        {
            timestamp: '2015-05-27',
            message: <Fragment><a href="https://www.youtube.com/watch?v=uPDQj2xvvTQ" target="_blank" rel="noopener noreferrer">Our contribution to the Rockstar Editor Video-Contest</a> was released</Fragment>
        },
        {
            timestamp: '2013-12-20',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#The Dosshouse 3'}>The Dosshouse 3</Link> was released</Fragment>
        },
        {
            timestamp: '2013-11-06',
            message: <Fragment>WikINM Facelift - completely new design was created</Fragment>
        },
        {
            timestamp: '2012-12-25',
            message: <Fragment>The christmas video for the year 2012 - <Link to={CONFIG.ROUTES.PROJECTS + '#Christmas carols and stuff (Christmas 2012)'}>Christmas carols and stuff</Link> - was released</Fragment>
        },
        {
            timestamp: '2012-12-18',
            message: <Fragment>WikINM Update: Guestbook entries are now distributed on pages. The entries per page can be adjusted.</Fragment>
        },
        {
            timestamp: '2012-12-15',
            message: <Fragment>WikINM is online again, after it was closed 2 weeks ago for no reason</Fragment>
        },
        {
            timestamp: '2012-10-26',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Aments of Bayside'}>Aments of Bayside</Link> was released</Fragment>
        },
        {
            timestamp: '2012-09-20',
            message: <Fragment>WikINM Update: Link to the forum was created (tab "Forum")</Fragment>
        },
        {
            timestamp: '2012-09-13',
            message: <Fragment>WikINM Update: Added security prompts to guestbook</Fragment>
        },
        {
            timestamp: '2012-09-08',
            message: <Fragment>Beta Test of Just Cause 2 Multiplayer (with wesone)</Fragment>
        },
        {
            timestamp: '2012-09-07',
            message: <Fragment>WikINM Update: The tab "More of INM" was added</Fragment>
        },
        {
            timestamp: '2012-07-01',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#The Chase'}>The Chase</Link> was released ("music video" for the titles "Dark Chase" and "Chased Till Dawn")</Fragment>
        },
        {
            timestamp: '2012-04-07',
            message: <Fragment>The tab "SAMP Server" now contains a version history including patch notes</Fragment>
        },
        {
            timestamp: '2012-03-16',
            message: <Fragment>WikINM structure was completely rewritten without any visual changes</Fragment>
        },
        {
            timestamp: '2012-02-10',
            message: <Fragment>INM published <a href="https://www.youtube.com/watch?v=hVVF3oYnqPo" target="_blank" rel="noopener noreferrer">Information to ACTA (Anti-Counterfeiting Trade Agreement)</a></Fragment>
        },
        {
            timestamp: '2012-01-08',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Ice Cold Killers'}>Ice Cold Killers</Link> (the result of the INM competition) was released</Fragment>
        },
        {
            timestamp: '2012-01-07',
            message: <Fragment>GTA IV Machinima Test was released</Fragment>
        },
        {
            timestamp: '2011-12-25',
            message: <Fragment>The christmas video for the year 2011 - <Link to={CONFIG.ROUTES.PROJECTS + '#28 Hours Before Christmas (Christmas 2011)'}>28 Hours Before Christmas</Link> - was released</Fragment>
        },
        {
            timestamp: '2011-11-12',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Zed 2: Recommended Gateway'}>Zed 2: Recommended Gateway</Link> was released</Fragment>
        },
        {
            timestamp: '2011-09-28',
            message: <Fragment>WikINM Update: In the tab "SAMP Server" a status display was added, which shows whether the server is "online" or "offline</Fragment>
        },
        {
            timestamp: '2011-09-27',
            message: <Fragment>WikINM Update: The tab "SAMP Server" was added</Fragment>
        },
        {
            timestamp: '2011-09-16',
            message: <Fragment>WikINM Update: It is now possible to subscribe to the newsletter</Fragment>
        },
        {
            timestamp: '2011-09-13',
            message: <Fragment>WikINM Update: Date of last visit extended by time</Fragment>
        },
        {
            timestamp: '2011-08-11',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Rolling Dope 2'}>Rolling Dope 2</Link> was released</Fragment>
        },
        {
            timestamp: '2011-08-05',
            message: <Fragment>WikINM Update: Order of guestbook entries was changed (thx Deadwood)</Fragment>
        },
        {
            timestamp: '2011-08-02',
            message: <Fragment>WikINM Update: People will see the date of their last visit on "Home"</Fragment>
        },
        {
            timestamp: '2011-08-01',
            message: <Fragment>Next project: Rolling Dope 2</Fragment>
        },
        {
            timestamp: '2011-07-28',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Restless Survivors'}>Restless Survivors</Link> was finished...</Fragment>
        },
        {
            timestamp: '2011-07-22',
            message: <Fragment>Work continues on Restless Survivors IV...</Fragment>
        },
        {
            timestamp: '2011-03-20',
            message: <Fragment>WikINM was opened...</Fragment>
        },
    ]
}
